import { useTranslation } from 'react-i18next';

import Header from '../../../styledComponents/PageDetails/HeaderPageDetails/HeaderPageDetails';
import FormErrorProvider from '../../../styledComponents/FormErrorProvider/FormErrorProvider';
import AddContractModal from '../../../styledComponents/Modals/AddContractModal/AddContractModal';
import Spinner from '../../../styledComponents/Spinner/Spinner';

import { ProductType } from '../../../models/ProductType';
import { useTLEditSubscriptionRenewPage } from './tlEditSubscriptionRenewPage.hooks';
import TLEditSubscriptionRenewPageForm from './TLSubscriptionRenewPageForm/tlSubscriptionRenewPageForm';

export const TLSubscriptionRenewPage = () => {
  const { t } = useTranslation();
  const { organization, dataLoading, loadDatesForNewSubscriptionHandler } =
    useTLEditSubscriptionRenewPage();

  if (dataLoading) {
    return <Spinner />;
  }

  return (
    <>
      <AddContractModal />
      <FormErrorProvider>
        <>
          <Header
            title={t('headers.edit-renew-subscription', {
              productType: ProductType.TravelLicense,
              organizationName: organization?.name,
            })}
          />
          <TLEditSubscriptionRenewPageForm
            onContractChanged={loadDatesForNewSubscriptionHandler}
          />
        </>
      </FormErrorProvider>
    </>
  );
};
